
export default function Contact() {
  return (
    <section id="contact" className="py-section bg-white">
      <div className="max-w-content mx-auto px-6">
        <div className="max-w-3xl mx-auto text-center">
          {/* Heading */}
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-semibold text-ink mb-6 tracking-tight">
            Get Your Proposal&nbsp;
          </h2>
          <p className="text-lg text-muted mb-4 max-w-xl mx-auto leading-relaxed">
            No in-home sales visit. No pressure. Just upload your window photos and get a locked-in price — fast.
          </p>

          {/* Trust pills */}
          <div className="flex flex-wrap items-center justify-center gap-3 mb-10">
            <div className="flex items-center gap-2 px-4 py-2 bg-[#D98CA3] rounded-full">
              <i className="ri-check-line text-white text-base"></i>
              <span className="text-white font-bold text-sm whitespace-nowrap">NO MONEY DOWN</span>
            </div>
            <div className="flex items-center gap-2 px-4 py-2 bg-[#52AB98] rounded-full">
              <i className="ri-check-line text-white text-base"></i>
              <span className="text-white font-semibold text-sm whitespace-nowrap">Locked-in pricing</span>
            </div>
            <div className="flex items-center gap-2 px-4 py-2 bg-[#52AB98] rounded-full">
              <i className="ri-check-line text-white text-base"></i>
              <span className="text-white font-semibold text-sm whitespace-nowrap">Licensed PM verifies measurements</span>
            </div>
          </div>

          {/* CTA Button */}
          <a
            href="https://api.leadconnectorhq.com/widget/form/0ZsIY0jYLaF8aXm2FeXI"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 px-10 py-5 bg-trust text-white text-lg font-bold rounded-2xl hover:bg-trust/90 transition-all cursor-pointer whitespace-nowrap shadow-xl hover:shadow-2xl hover:scale-[1.02] transform"
          >
            Get My Proposal
            <i className="ri-arrow-right-line text-xl"></i>
          </a>

          <p className="text-sm text-muted mt-6 flex items-center justify-center gap-2">
            <i className="ri-lock-line"></i>
            Your info stays private. No spam, ever.
          </p>
        </div>
      </div>
    </section>
  );
}
